import { CustomIcon } from '@tymbe/ui-icons';
import classNames from 'classnames';

type ChatProps = {
  className?: string;
}

const Chat = ({ className }: ChatProps) => {
  const openChat = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.smartsupp?.('chat:open');
  };
  return (
    <div className={classNames('flex items-center gap-4 @[100px]:pl-10 pl-4', className)}>
      <button
        className="size-10 p-2.5 bg-primary-300 rounded-full"
        onClick={openChat}
      >
        <CustomIcon name="Chat" className="text-secondary-600" />
      </button>
    </div>
  );
};

export default Chat;
